const initialState = {
    fullScreenVale: false,
};

const screenReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FullScreen':
            return {
                ...state,
                fullScreenVale: action.payload,
            };
        case 'LOGOUT':
            return {
                ...state,
                fullScreenVale: false,
            };
        default:
            return state;
    }
};

export default screenReducer;